import { useEffect, useState, Suspense } from "react";
import { useHistory } from "react-router-dom";
import logo1 from "../../../assets/images/s.png";
import logo from "../../../../src/assets/images/MAARGLOGONoTagLineSmaller.png";
import fbImg from "../../../../src/assets/images/fb.png";
import twitterImg from "../../../../src/assets/images/twit.png";
import LanguageIcon from "./langauageIcon";
import linkedIn from "../../../../src/assets/images/linkedin.png";
import youTube from "../../../../src/assets/images/youtube.png";
import Profile from "../../StartupForms/LoginModal/Profile";
import { googleLogout } from "@react-oauth/google";
import "./styles.scss";
import LoggedInImage from "../../../assets/images/loggedInUser.png";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
  ClickAwayListener,
  IconButton,
  InputBase,
  TextField,
  Tooltip,
} from "@material-ui/core";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
  },
}));

const Header = (props) => {
  const classes = useStyles();
  const [language, setLanguage] = useState(false);

  const [data, setData] = useState();
  const [username, setUserName] = useState();
  const [searchTooltipOpen, setSearchTooltipOpen] = useState(false);
  const { t } = useTranslation();
  let history = useHistory();
  useEffect(() => {
    try {
      let value = localStorage.getItem("SavedLoggedInData");
      setData(JSON.parse(value));
      let value2 = JSON.parse(value);
      if (value2.applicant_name.length > 10) {
        let firstName = value2.applicant_name.replace(/ .*/, "");
        setUserName(firstName);
      } else {
        setUserName(value2.applicant_name);
      }
    } catch (error) { }
  }, []);
  useEffect(() => {
    if (localStorage.getItem("SelectedLang") === null) {
      setLanguage("en");
    } else if (localStorage.getItem("SelectedLang")) {
      setLanguage(localStorage.getItem("SelectedLang"));
    }

  }, []);
  const logoutClick = () => {
    localStorage.clear();
    // window.FB.logout();
    googleLogout();
    localStorage.removeItem("SavedLoggedInData");
    localStorage.removeItem("loggedIn");
    sessionStorage.removeItem("fbssls_");
    // sessionStorage.clear();
    // localStorage.clear();
    // sessionStorage.clear();
    // var cookies = document.cookie;

    // for (var i = 0; i < cookies.split(";").length; ++i)
    // {
    //     var myCookie = cookies[i];
    //     var pos = myCookie.indexOf("=");
    //     var name = pos > -1 ? myCookie.substr(0, pos) : myCookie;
    //     document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    // }
    toast.success("Logged Out", {
      position: "top-right",
      autoClose: 2000,
    });
    setTimeout(function () {
      history.push(`/login`);
    }, 3000); //run this after 3 seconds
  };

  const openDashboard = () => {
    try {
      if (localStorage.getItem("loggedIn") === "true") {
        let value = localStorage.getItem("SavedLoggedInData");
        let LoginFormData = JSON.parse(value);
        if (LoginFormData?.role == "Startup") {
          // history.push({
          //   pathname: "/get-a-mentor",
          //   state: LoginFormData,
          // });
          history.push({
            pathname: "/startup-dashboard",
            state: LoginFormData,
          });

          localStorage.removeItem("myRequests");
          localStorage.removeItem("startupAllMentorList");
          localStorage.removeItem("mentorStartupRequest");
          localStorage.removeItem("startUpRequests");
          localStorage.removeItem("CohortStartupRequest");
          localStorage.removeItem("cohortMentorshipsStartup");

          window.location.reload();
        } else if (LoginFormData?.role == "Mentor") {
          // need to add condition which page need to show
          if (LoginFormData.applicationSatus === "PENDING") {
            history.push({
              pathname: "/become-a-mentor",
              state: LoginFormData,
            });
          } else {
            history.push({
              pathname: "/dashboard",
              state: LoginFormData,
            });
          }
        } else if (LoginFormData?.role == "Admin") {
          history.push({
            pathname: "/dashboard",
          });
        }
      } else {
        history.push({
          pathname: "/login",
        });
      }
    } catch (error) { }
  };
  const changeLanguagePortal = (lang) => {
    var lo = localStorage.getItem("SelectedLang");
    localStorage.setItem("SelectedLang", lang);
    if (lang === "hindi" || localStorage.getItem("SelectedLang") === "hindi") {

      if (history.location.pathname.indexOf("hindi") > -1) {
      } else {
        clearSelectedLanguages(lang);
      }
    } else if (lang === "telugu" || localStorage.getItem("SelectedLang") === "telugu") {
      if (history.location.pathname.indexOf("telugu") > -1) {
      } else {
        clearSelectedLanguages(lang);
      }
    } else if (lang === "en" || localStorage.getItem("SelectedLang") === "en") {
      clearSelectedLanguages("en");
    } else if (
      lang === "bengali" ||
      localStorage.getItem("SelectedLang") === "bengali"
    ) {
      if (history.location.pathname.indexOf("bengali") > -1) {
      } else {

        clearSelectedLanguages(lang);
      }
    } else if (
      lang === "marathi" ||
      localStorage.getItem("SelectedLang") === "marathi"
    ) {
      if (history.location.pathname.indexOf("marathi") > -1) {
      } else {
        clearSelectedLanguages(lang);
      }
    } else if (
      lang === "oriya" ||
      localStorage.getItem("SelectedLang") === "oriya"
    ) {
      if (history.location.pathname.indexOf("oriya") > -1) {
      } else {
        clearSelectedLanguages(lang);
      }
    } else if (
      lang === "assamese" ||
      localStorage.getItem("SelectedLang") === "assamese"
    ) {
      if (history.location.pathname.indexOf("assamese") > -1) {
      } else {
        clearSelectedLanguages(lang);
      }
    } else if (
      lang === "malayalam" ||
      localStorage.getItem("SelectedLang") === "malayalam"
    ) {
      if (history.location.pathname.indexOf("malayalam") > -1) {
      } else {
        clearSelectedLanguages(lang);
      }
    } else if (
      lang === "tamil" ||
      localStorage.getItem("SelectedLang") === "tamil"
    ) {
      if (history.location.pathname.indexOf("tamil") > -1) {
      } else {
        clearSelectedLanguages(lang);
      }
    } else if (
      lang === "gujarati" ||
      localStorage.getItem("SelectedLang") === "gujarati"
    ) {
      if (history.location.pathname.indexOf("gujarati") > -1) {
      } else {
        clearSelectedLanguages(lang);
      }
    } else if (
      lang === "kannada" ||
      localStorage.getItem("SelectedLang") === "kannada"
    ) {
      if (history.location.pathname.indexOf("kannada") > -1) {
      } else {
        clearSelectedLanguages(lang);
      }
    } else if (
      lang === "punjabi" ||
      localStorage.getItem("SelectedLang") === "punjabi"
    ) {
      if (history.location.pathname.indexOf("punjabi") > -1) {
      } else {
        clearSelectedLanguages(lang);
      }
    } else {
      clearSelectedLanguages("en");

    }
  };
  const clearStorage = () => {
    for (var a in localStorage) {
      if (a === "activePage") {

      } else if (a === "SelectedLang") {

      } else if (a === "loggedIn") {

      } else if (a === "SavedLoggedInData") {

      } else if (a === "ProgressReport") {

      } else {
        localStorage.removeItem(a);
      }
    }
  };
  const clearSelectedLanguages = (newLang) => {
    var orgpath = "";
    var path = "";
    if (history.location.pathname.indexOf("hindi") > -1) {
      orgpath = window.location.origin.replace(new RegExp("/hindi"), "");
      path = history.location.pathname.replace(new RegExp("/hindi"), "");

    } else if (history.location.pathname.indexOf("telugu") > -1) {
      orgpath = window.location.origin.replace(new RegExp("/telugu"), "");
      path = history.location.pathname.replace(new RegExp("/telugu"), "");
      // window.open(orgpath + path, "_self");
    } else if (history.location.pathname.indexOf("bengali") > -1) {
      orgpath = window.location.origin.replace(new RegExp("/bengali"), "");
      path = history.location.pathname.replace(new RegExp("/bengali"), "");
      // window.open(orgpath + path, "_self");
    } else if (history.location.pathname.indexOf("marathi") > -1) {
      orgpath = window.location.origin.replace(new RegExp("/marathi"), "");
      path = history.location.pathname.replace(new RegExp("/marathi"), "");
      // window.open(orgpath + path, "_self");
    } else if (history.location.pathname.indexOf("oriya") > -1) {
      orgpath = window.location.origin.replace(new RegExp("/oriya"), "");
      path = history.location.pathname.replace(new RegExp("/oriya"), "");
      // window.open(orgpath + path, "_self");
    } else if (history.location.pathname.indexOf("assamese") > -1) {
      orgpath = window.location.origin.replace(new RegExp("/assamese"), "");
      path = history.location.pathname.replace(new RegExp("/assamese"), "");
      // window.open(orgpath + path, "_self");
    } else if (history.location.pathname.indexOf("malayalam") > -1) {
      orgpath = window.location.origin.replace(new RegExp("/malayalam"), "");
      path = history.location.pathname.replace(new RegExp("/malayalam"), "");
      // window.open(orgpath + path, "_self");
    } else if (history.location.pathname.indexOf("tamil") > -1) {
      orgpath = window.location.origin.replace(new RegExp("/tamil"), "");
      path = history.location.pathname.replace(new RegExp("/tamil"), "");
      // window.open(orgpath + path, "_self");
    } else if (history.location.pathname.indexOf("gujarati") > -1) {
      orgpath = window.location.origin.replace(new RegExp("/gujarati"), "");
      path = history.location.pathname.replace(new RegExp("/gujarati"), "");
      // window.open(orgpath + path, "_self");
    } else if (history.location.pathname.indexOf("kannada") > -1) {
      orgpath = window.location.origin.replace(new RegExp("/kannada"), "");
      path = history.location.pathname.replace(new RegExp("/kannada"), "");
      // window.open(orgpath + path, "_self");
    } else if (history.location.pathname.indexOf("punjabi") > -1) {
      orgpath = window.location.origin.replace(new RegExp("/punjabi"), "");
      path = history.location.pathname.replace(new RegExp("/punjabi"), "");
    }
    else {
      orgpath = window.location.origin.replace(new RegExp("/hindi"), "");
      path = history.location.pathname.replace(new RegExp("/hindi"), "");
    }

    clearStorage();

    if (newLang === "en" || localStorage.getItem("SelectedLang") == null) {
      window.open(orgpath + path, "_self")
    } else {
      window.open(orgpath + "/" + newLang + path, "_self")

    }
  }

  return (
    <Suspense fallback="loading">
      <main
        style={{ zIndex: 998, position: "fixed", top: 0, left: 0 }}
        className="mainheaderdiv"
      >
        <header className="style1 w-100">
          <div className="topbar bg-color4 w-100">
            <div className="container" style={{ maxWidth: "1270px" }}>
              <div className="topbar-inner d-flex flex-wrap align-items-center justify-content-between w-100">
                <ul className="top-info-links d-inline-flex flex-wrap align-items-center list-unstyled mb-0">
                  <li>
                    <img src={logo1} alt="Logo"></img>
                  </li>
                  <li>
                    <p> ﻿भारत सरकार </p> <p> GOVERNMENT OF INDIA </p>
                  </li>
                  <li>
                    <p> वाणिज्य एवं उद्योग मंत्रालय </p>
                    <p> MINISTRY OF COMMERCE AND INDUSTRY </p>
                  </li>
                  <li>
                    <p> उद्योग संवर्धन और आंतरिक व्यापार विभाग </p>
                    <p>
                      DEPARTMENT FOR PROMOTION OF INDUSTRY AND INTERNAL TRADE
                    </p>
                  </li>
                </ul>
                <div className="social-cart d-inline-flex flex-wrap align-items-center">
                  <div className="header-cart-box position-relative d-inline-block">
                    <a href="tel:1800 115 565"> Toll Free: 1800 115 565 </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="menubar w-100">
            <div className="container w-100" style={{ maxWidth: "1270px" }}>
              {/* justify-content-between  */}
              <div className="menubar-inner d-flex flex-wrap justify-content-between  align-items-center w-100 pb-1">
                <div className="logo">
                  <h1 className="m-0">
                    <a
                      href="/"
                      onClick={() => localStorage.removeItem("activePage")}
                      title="Home"
                    >
                      <img className="logoImage" src={logo} alt="Logo"></img>
                    </a>
                  </h1>
                </div>
                <nav>
                  <ul className="d-inline-flex flex-wrap align-items-center mb-0 list-unstyled">
                    <li style={{ display: "none" }}>
                      <div
                        style={{
                          border: "1px solid #563A96",
                          height: "30px",
                          padding: "2px",
                          width: "80px",
                          fontFamily: "Montserrat",
                        }}
                        className="languagedropdownheader"
                      >
                        <p
                          style={{
                            color: "#563A96",
                          }}
                        >
                          {" "}
                          English
                        </p>
                      </div>
                    </li>
                    <li
                      className={
                        localStorage.getItem("activePage") === "home" || localStorage.getItem("activePage") === "/" || localStorage.getItem("activePage") === undefined
                          ? "activePage"
                          : ""
                      }
                    >
                      <a
                        href={localStorage.getItem("SelectedLang") != "en" && localStorage.getItem("SelectedLang") != null ? "/" + localStorage.getItem("SelectedLang") + "/" : "/"}
                        onClick={() =>
                          localStorage.setItem("activePage", "home")
                        }
                        title=""
                      >

                        {t("HOME")}
                      </a>
                    </li>
                    <li
                      className={
                        localStorage.getItem("activePage") === "aboutus"
                          ? "activePage"
                          : ""
                      }
                    >
                      <a
                        href={localStorage.getItem("SelectedLang") != "en" && localStorage.getItem("SelectedLang") != null ? "/" + localStorage.getItem("SelectedLang") + "/about-us" : "/about-us"}
                        onClick={() =>
                          localStorage.setItem("activePage", "aboutus")
                        }
                        title=""
                      >
                        {" "}
                        {t("About_US")}
                      </a>
                    </li>
                    <li
                      className={
                        localStorage.getItem("activePage") === "becomeMentor"
                          ? "activePage"
                          : ""
                      }
                    >
                      <a
                        href={localStorage.getItem("SelectedLang") != "en" && localStorage.getItem("SelectedLang") != null ? "/" + localStorage.getItem("SelectedLang") + "/become-mentor" : "/become-mentor"}
                        onClick={() =>
                          localStorage.setItem("activePage", "becomeMentor")
                        }
                        title=""
                      >
                        {" "}
                        {t("BECOME_A_MENTOR")}{" "}
                      </a>
                    </li>
                    <li
                      className={
                        localStorage.getItem("activePage") === "findMentor"
                          ? "activePage"
                          : ""
                      }
                    >
                      <a
                        href={localStorage.getItem("SelectedLang") != "en" && localStorage.getItem("SelectedLang") != null ? "/" + localStorage.getItem("SelectedLang") + "/get-a-mentor" : "/get-a-mentor"}
                        onClick={() =>
                          localStorage.setItem("activePage", "findMentor")
                        }
                        title=""
                      >
                        {" "}
                        {t("GET_A_MENTOR")}{" "}
                      </a>
                    </li>
                    <li
                      className={
                        localStorage.getItem("activePage") === "cohortProgram"
                          ? "activePage"
                          : ""
                      }
                    >
                      <a
                        href={localStorage.getItem("SelectedLang") != "en" && localStorage.getItem("SelectedLang") != null ? "/" + localStorage.getItem("SelectedLang") + "/cohort-program" : "/cohort-program"}
                        onClick={() =>
                          localStorage.setItem("activePage", "cohortProgram")
                        }
                        title=""
                      >
                        {" "}
                        {t("COHORT_PROGRAMS")}
                      </a>
                    </li>
                    <li
                      className={
                        localStorage.getItem("activePage") === "FAQ"
                          ? "activePage"
                          : ""
                      }
                    >
                      <a
                        style={{
                          textTransform: "none",
                        }}
                        href={localStorage.getItem("SelectedLang") != "en" && localStorage.getItem("SelectedLang") != null ? "/" + localStorage.getItem("SelectedLang") + "/faq" : "/faq"}
                        onClick={() =>
                          localStorage.setItem("activePage", "FAQ")
                        }
                        title=""
                      >
                        {" "}
                        {t("FAQs")}
                        {/* FAQs */}
                      </a>
                    </li>
                    <li
                      className={
                        localStorage.getItem("activePage") === "contactus"
                          ? "activePage"
                          : ""
                      }
                    >
                      <a
                        href={localStorage.getItem("SelectedLang") != "en" && localStorage.getItem("SelectedLang") != null ? "/" + localStorage.getItem("SelectedLang") + "/contactus" : "/contactus"}
                        onClick={() =>
                          localStorage.setItem("activePage", "contactus")
                        }
                        title=""
                      >
                        {" "}
                        {t("CONTACT")}
                        {/* Contact */}
                      </a>
                    </li>
                  </ul>
                </nav>
                <div className="social-links d-inline-flex flex-wrap">
                  {/* <div className="newuserTooltip" style={{ padding: "0 1px" }}>
                    <a
                      href="https://www.linkedin.com/company/startup-india/"
                      // title="Linkedin"
                      target="_blank"
                    >
                      <img src={linkedIn} />
                    </a>
                    <span
                      className="tooltiptext  tooltip-bottom"
                      style={{ left: "32px", top: "33px", width: "90px" }}
                    >
                      LinkedIn
                    </span>
                  </div>
                  <div className="newuserTooltip" style={{ padding: "0 1px" }}>
                    <a
                      href="https://twitter.com/startupindia?lang=en"
                      // title="Twitter"
                      target="_blank"
                    >
                      <img src={twitterImg} />
                    </a>
                    <span
                      className="tooltiptext  tooltip-bottom"
                      style={{ left: "32px", top: "33px", width: "90px" }}
                    >
                      Twitter
                    </span>
                  </div>
                  <div className="newuserTooltip" style={{ padding: "0 1px" }}>
                    <a
                      href="https://www.facebook.com/StartupIndia/"
                      // title="Facebook"
                      target="_blank"
                    >
                      <img src={fbImg} />
                    </a>
                    <span
                      className="tooltiptext  tooltip-bottom"
                      style={{ left: "32px", top: "33px", width: "90px" }}
                    >
                      Facebook
                    </span>
                  </div>
                  <div className="newuserTooltip" style={{ padding: "0 1px" }}>
                    <a
                      href="https://www.youtube.com/channel/UCqFb-ynHTJ6_YRbdn-sFUvg/featured"
                      // title="Youtube"
                      target="_blank"
                    >
                      <img src={youTube} />
                    </a>
                    <span
                      className="tooltiptext  tooltip-bottom"
                      style={{ left: "32px", top: "33px", width: "90px" }}
                    >
                      Youtube
                    </span>
                  </div> */}
                </div>
                <div>
                  <div
                    className="languageBtn tooltip7"
                    style={{ opacity: "1" }}
                  >
                    <div className="w-100 h-100">
                      <LanguageIcon width={"35px"} height={"35px"} />
                    </div>
                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-translate" viewBox="0 0 16 16">
  <path d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286H4.545zm1.634-.736L5.5 3.956h-.049l-.679 2.022H6.18z"/>
  <path d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2V2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2zm7.138 9.995c.193.301.402.583.63.846-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6.066 6.066 0 0 1-.415-.492 1.988 1.988 0 0 1-.94.31z"/>
</svg> */}
                    {/* <span id="profileDrop" className="tooltiptext7">
          <div className="col-md-12 animated fadeIn">
            <div className="card">
              <div className="card-body">
               
      
     
                <p>
                  {" "}
                  <button
                    className="thm-logout"
                    onClick={() => logoutClick()}
                    title=""
                  >
                    English
                  </button>
                </p>
              </div>
            </div>
          </div>
        </span> */}
                    <span id="profileDrop" className="tooltiptext7-profile">
                      <div className="col-md-12 animated fadeIn">
                        <div className="card" style={{ height: "300px" }}>
                          <div
                            className="card-body2"
                            style={{ background: "#E6E7E8", height: "300px" }}
                          >
                            <div
                              className="d-flex justify-content-center"
                              style={{
                                maxHeight: "285px",
                                flexDirection: "column",
                              }}
                            >
                              {" "}
                              <div
                                style={{ maxHeight: "24px", cursor: "pointer" }}
                              >
                                <h5
                                  // className={active ? "thm-language" : "thm-language-inactive"}
                                  className={
                                    language === "en"
                                      ? "thm-language-active"
                                      : "thm-language"
                                  }
                                  onClick={() => {
                                    changeLanguagePortal("en");
                                    setLanguage("en");
                                  }}
                                  title=""
                                >
                                  English
                                </h5>
                              </div>{" "}
                              <div
                                style={{ maxHeight: "24px", cursor: "pointer" }}
                              >
                                <h5
                                  // className={active ? "thm-language" : "thm-language-inactive"}
                                  className={
                                    language === "hindi"
                                      ? "thm-language-active"
                                      : "thm-language"
                                  }
                                  onClick={() => {
                                    changeLanguagePortal("hindi");
                                    setLanguage("hindi");
                                  }}
                                  // onClick={() => logoutClick()}
                                  title=""
                                >
                                  Hindi
                                </h5>
                              </div>
                              <div
                                style={{ maxHeight: "24px", cursor: "pointer" }}
                              >
                                <h5
                                  // className={active ? "thm-language" : "thm-language-inactive"}
                                  className={
                                    language === "telugu"
                                      ? "thm-language-active"
                                      : "thm-language"
                                  }
                                  onClick={() => {
                                    changeLanguagePortal("telugu");
                                    setLanguage("telugu");
                                  }}
                                  title=""
                                >
                                  Telugu
                                </h5>
                              </div>
                              <div
                                style={{ maxHeight: "24px", cursor: "pointer" }}
                              >
                                <h5
                                  // className={active ? "thm-language" : "thm-language-inactive"}
                                  className={
                                    language === "bengali"
                                      ? "thm-language-active"
                                      : "thm-language"
                                  }
                                  onClick={() => {
                                    changeLanguagePortal("bengali");
                                    setLanguage("bengali");
                                  }}
                                  // onClick={() => logoutClick()}
                                  title=""
                                >
                                  Bengali
                                </h5>
                              </div>
                              <div
                                style={{ maxHeight: "24px", cursor: "pointer" }}
                              >
                                <h5
                                  // className={active ? "thm-language" : "thm-language-inactive"}
                                  className={
                                    language === "marathi"
                                      ? "thm-language-active"
                                      : "thm-language"
                                  }
                                  onClick={() => {
                                    changeLanguagePortal("marathi");
                                    setLanguage("marathi");
                                  }}
                                  // onClick={() => logoutClick()}
                                  title=""
                                >
                                  Marathi
                                </h5>
                              </div>
                              <div
                                style={{ maxHeight: "24px", cursor: "pointer" }}
                              >
                                <h5
                                  // className={active ? "thm-language" : "thm-language-inactive"}
                                  className={
                                    language === "oriya"
                                      ? "thm-language-active"
                                      : "thm-language"
                                  }
                                  onClick={() => {
                                    changeLanguagePortal("oriya");
                                    setLanguage("oriya");
                                  }}
                                  // onClick={() => logoutClick()}
                                  title=""
                                >
                                  Oriya
                                </h5>
                              </div>
                              <div
                                style={{ maxHeight: "24px", cursor: "pointer" }}
                              >
                                <h5
                                  // className={active ? "thm-language" : "thm-language-inactive"}
                                  className={
                                    language === "assamese"
                                      ? "thm-language-active"
                                      : "thm-language"
                                  }
                                  onClick={() => {
                                    changeLanguagePortal("assamese");
                                    setLanguage("assamese");
                                  }}
                                  // onClick={() => logoutClick()}
                                  title=""
                                >
                                  Assamese
                                </h5>
                              </div>
                              <div
                                style={{ maxHeight: "24px", cursor: "pointer" }}
                              >
                                <h5
                                  // className={active ? "thm-language" : "thm-language-inactive"}
                                  className={
                                    language === "malayalam"
                                      ? "thm-language-active"
                                      : "thm-language"
                                  }
                                  onClick={() => {
                                    changeLanguagePortal("malayalam");
                                    setLanguage("malayalam");
                                  }}
                                  // onClick={() => logoutClick()}
                                  title=""
                                >
                                  Malayalam
                                </h5>
                              </div>
                              <div
                                style={{ maxHeight: "24px", cursor: "pointer" }}
                              >
                                <h5
                                  // className={active ? "thm-language" : "thm-language-inactive"}
                                  className={
                                    language === "tamil"
                                      ? "thm-language-active"
                                      : "thm-language"
                                  }
                                  onClick={() => {
                                    changeLanguagePortal("tamil");
                                    setLanguage("tamil");
                                  }}
                                  // onClick={() => logoutClick()}
                                  title=""
                                >
                                  Tamil
                                </h5>
                              </div>
                              <div
                                style={{ maxHeight: "24px", cursor: "pointer" }}
                              >
                                <h5
                                  // className={active ? "thm-language" : "thm-language-inactive"}
                                  className={
                                    language === "gujarati"
                                      ? "thm-language-active"
                                      : "thm-language"
                                  }
                                  onClick={() => {
                                    changeLanguagePortal("gujarati");
                                    setLanguage("gujarati");
                                  }}
                                  // onClick={() => logoutClick()}
                                  title=""
                                >
                                  Gujarati
                                </h5>
                              </div>
                              <div
                                style={{ maxHeight: "24px", cursor: "pointer" }}
                              >
                                <h5
                                  // className={active ? "thm-language" : "thm-language-inactive"}
                                  className={
                                    language === "kannada"
                                      ? "thm-language-active"
                                      : "thm-language"
                                  }
                                  onClick={() => {
                                    changeLanguagePortal("kannada");
                                    setLanguage("kannada");
                                  }}
                                  // onClick={() => logoutClick()}
                                  title=""
                                >
                                  Kannada
                                </h5>
                              </div>
                              <div
                                style={{ maxHeight: "24px", cursor: "pointer" }}
                              >
                                <h5
                                  // className={active ? "thm-language" : "thm-language-inactive"}
                                  className={
                                    language === "punjabi"
                                      ? "thm-language-active"
                                      : "thm-language"
                                  }
                                  onClick={() => {
                                    changeLanguagePortal("punjabi");
                                    setLanguage("punjabi");
                                  }}
                                  // onClick={() => logoutClick()}
                                  title=""
                                >
                                  Punjabi
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>

                {/* <Tooltip
                  placement="left"
                  open={searchTooltipOpen}
                  interactive
                  style={{ zIndex: 1000 }}
                  classes={{
                    tooltip: classes.root,
                    tooltipArrow: classes.root,
                  }}
                  title={
                    <ClickAwayListener
                      onClickAway={() => setSearchTooltipOpen(false)}
                    >
                      <InputBase
                        placeholder="Search MAARG"
                        style={{
                          backgroundColor: "white",
                          borderRadius: "3px",
                          padding: "5px 12px",
                          fontFamily: "Montserrat",
                          fontSize: "14px",
                          border: "2px solid #b499c7",
                        }}
                      />
                    </ClickAwayListener>
                  }
                >
                  <IconButton
                    style={{ backgroundColor: "rgba(0,0,0,0.05)" }}
                    onClick={() => setSearchTooltipOpen(true)}
                  >
                    <SearchRoundedIcon />
                  </IconButton>
                </Tooltip> */}

                <div className="header-btns d-inline-flex flex-wrap align-items-center browserCompatible">
                  <div className="wrap" style={{ display: "none" }}>
                    <div className="search">
                      <input
                        type="text"
                        className="searchTerm"
                        placeholder=""
                      />
                      <button type="submit" className="searchButton">
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                  <div className="tooltip1 p-0">
                    {localStorage.getItem("loggedIn") === "true" ? (
                      <Profile username={username} />
                    ) : (
                      <div className="newUserTooltip">
                        <a href="/login">
                          <img
                            src={LoggedInImage}
                            style={{
                              float: "right",
                              height: "50px",
                              // marginRight: "1rem",
                            }}
                          />
                        </a>
                        <span className="tooltiptext tooltip-bottom">
                          Login
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div className="header-search d-flex flex-wrap justify-content-center align-items-center w-100">
          <span className="search-close-btn">
            <i className="fas fa-times" />
          </span>
          <form>
            <input type="search" placeholder="Search" />
          </form>
        </div>
        <div className="w-100 container d-flex flex-wrap justify-content-between navbarFirst">
          <div>
            <div className="navbarTopText">
              {" "}
              उद्योग संवर्धन और आंतरिक व्यापार विभाग{" "}
            </div>

            <div className="navbarTopText2">
              DEPARTMENT FOR PROMOTION OF INDUSTRY AND INTERNAL TRADE
            </div>
          </div>
          <div>
            <div className="navbarTopText3">Toll Free Number</div>
            <div className="navbarTopNumber">1800 115 565</div>
          </div>
        </div>

        <div className="responsive-header position-relative w-100">
          <div className="responsive-topbar w-100">
            <div className="container d-flex flex-wrap align-items-center">
              <div className="d-flex">
                <a
                  className="res-menu-btn d-inline-block menuMobile"
                  href="javascript:void(0);"
                  title
                >
                  <i className="fas fa-align-justify" />
                </a>
                <div className="logo">
                  <a
                    href="/"
                    title="Home"
                    style={{ position: "relative", left: "20px", top: "-2px" }}
                  >
                    <img className="img-fluid logoImage" src={logo} alt="Logo" />
                  </a>
                </div>
              </div>

              <div className="headxer-btns d-inline-flex flex-wrap align-items-center">
                {/* <div className="social-links d-inline-flex flex-wrap">
                  <a
                    href="https://www.linkedin.com/company/startup-india/"
                    title="Linkedin"
                    target="_blank"
                  >
                    <img src={linkedIn} />
                  </a>

                  <a
                    href="https://twitter.com/startupindia?lang=en"
                    title="Twitter"
                    target="_blank"
                  >
                    <img src={twitterImg} />
                  </a>
                  <a
                    href="https://www.facebook.com/StartupIndia/"
                    title="Facebook"
                    target="_blank"
                  >
                    <img src={fbImg} />
                  </a>
                  <a
                    href="https://www.youtube.com/channel/UCqFb-ynHTJ6_YRbdn-sFUvg/featured"
                    title="Youtube"
                    target="_blank"
                  >
                    <img src={youTube} />
                  </a>
                  {localStorage.getItem("loggedIn") === "true" ? (
                    <div className="tooltip1 text-end">
                      <div className="d-flex justify-content-end">
                        <img
                          src={LoggedInImage}
                          style={{
                            float: "right",
                            height: "40px",
                          }}
                        />
                      </div>
                      <span id="profileDrop" className="tooltiptext1-profile">
                        <div className="col-md-12 animated fadeIn">
                          <div className="card">
                            <div className="card-body">
                              <div className="avatar">
                                <img
                                  src={data?.image && data?.image}
                                  className="card-img-top"
                                  alt=""
                                />
                              </div>
                              <div className="d-flex justify-content-center">
                                <h5 className="card-title">
                                  {data?.applicant_name}
                                </h5>
                              </div>
                              <div className="d-flex justify-content-center">
                                <h5
                                  style={{ cursor: "pointer" }}
                                  className="card-title log-dashboard-head "
                                  onClick={() => openDashboard()}
                                >
                                  <span>My Dashboard</span>
                                </h5>
                              </div>
                              <div className="d-flex justify-content-center">
                                <p>
                                  {" "}
                                  <button
                                    className="thm-logout"
                                    onClick={() => logoutClick()}
                                    title=""
                                  >
                                    Log Out
                                  </button>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </span>
                    </div>
                  ) : (
                    <div className="menubar header-btns d-inline-flex flex-wrap align-items-center ">
                      <div className="wrap" style={{ display: "none" }}>
                        <div className="search">
                          <input
                            type="text"
                            className="searchTerm"
                            placeholder=""
                          />
                          <button type="submit" className="searchButton">
                            <i className="fa fa-search"></i>
                          </button>
                        </div>
                      </div>
                      <div className="tooltip1">
                        {localStorage.getItem("loggedIn") === "true" ? (
                          <Profile />
                        ) : (
                          <a href="/login">
                            <img
                              src={LoggedInImage}
                              style={{
                                float: "right",
                                height: "40px",
                                marginRight: "1rem",
                              }}
                            />
                          </a>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="tooltip1 text-end">
                    <span id="profileDrop" className="tooltiptext1-profile">
                      <div className="col-md-12 animated fadeIn">
                        <div className="card">
                          <div className="card-body">
                            <div className="avatar">
                              <img
                                src={data?.image && data?.image}
                                className="card-img-top"
                                alt=""
                              />
                            </div>
                            <h5 className="card-title">
                              {data?.applicant_name}
                            </h5>
                            <h5
                              style={{ cursor: "pointer" }}
                              className="card-title log-dashboard-head "
                              onClick={() => openDashboard()}
                            >
                              <span>My Dashboard</span>
                            </h5>
                            <p>
                              {" "}
                              <button
                                className="thm-logout"
                                onClick={() => logoutClick()}
                                title=""
                              >
                                Log Out
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                </div> */}
                {localStorage.getItem("loggedIn") === "true" ? (
                  <div className="d-flex justify-content-end welcomeTextWrapper">
                    <h5 className="text-nowrap welcomeText">
                      Welcome {username}
                    </h5>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {/* <div className="menubar header-btns d-inline-flex flex-wrap align-items-center d-none">
              <div className="wrap" style={{ display: "none" }}>
                <div className="search">
                  <input type="text" className="searchTerm" placeholder="" />
                  <button type="submit" className="searchButton">
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </div>
              <div className="tooltip1">
                {localStorage.getItem("loggedIn") === "true" ? (
                  <Profile />
                ) : (
                  ""
                  // <a
                  //   onClick={() => localStorage.removeItem("activePage")}
                  //   className="thm-btn brd-btn rounded-pill d-inline-block "
                  //   href="/login"
                  //   title=""
                  // >
                  //   Login
                  // </a>
                )}
              </div>
            </div> */}
            </div>
          </div>
          <div className="responsive-menu w-100">
            <div className="logow w mt-2">
              <h1 className="mb-0">
                <a href="/" title="Home">
                  <img
                    className="img-fluid logoImage"
                    src={logo}
                    alt="Logo"
                    style={{ margin: "0 auto" }}
                  />
                </a>
              </h1>
            </div>
            {/* Logo */}
            <ul className="mb-0 list-unstyled w-100">
              <li>
                <a href="/" title="Home">
                  {t("Home")}
                </a>
              </li>
              <li>
                <a href="/about-us" title="About us">
                  {t("About_US")}
                </a>
              </li>
              <li>
                <a href="/become-mentor" title="Become Mentor">
                  Become a mentor
                </a>
              </li>
              <li>
                <a href="/get-a-mentor" title="Get a Mentor">
                  Get a Mentor
                </a>
              </li>
              <li>
                <a href="/cohort-program" title>
                  Cohorts
                </a>
              </li>
              <li>
                <a href="/faq" title>
                  FAQs
                </a>
              </li>
              <li>
                <a href="/contactus" title>
                  Contact Us
                </a>
              </li>
            </ul>
            <ul
              className=" d-inline-flex flex-wrap align-items-center list-unstyled mb-0 mbMenu"
              style={{ background: "#b499c7" }}
            >
              <li
                style={{
                  display: "flex",
                  padding: "10px 0px",
                  flexDirection: "column",
                }}
              >
                <div className="d-flex justify-content-center">
                  <img src={logo1} alt="Logo"></img>
                </div>
                <div>
                  <div className="mobileListItem">भारत सरकार </div>
                </div>
                <div>
                  <div className="mobileListItem2">GOVERNMENT OF INDIA </div>
                </div>
              </li>
              <li>
                <div className="mobileListItem">
                  {" "}
                  वाणिज्य एवं उद्योग मंत्रालय{" "}
                </div>
                <div className="mobileListItem2">
                  {" "}
                  MINISTRY OF COMMERCE AND INDUSTRY{" "}
                </div>
              </li>
              <li>
                <div className="mobileListItem">
                  {" "}
                  उद्योग संवर्धन और आंतरिक व्यापार विभाग{" "}
                </div>
                <div className="mobileListItem2">
                  DEPARTMENT FOR PROMOTION OF INDUSTRY AND INTERNAL TRADE
                </div>
              </li>

              {/* <li>
              <div>
                <a href="tel:1800 115 565"> Toll Free: 1800 115 565 </a>
              </div>
            </li> */}
            </ul>
          </div>
        </div>
      </main>
    </Suspense>
  );
};

export default Header;
